import React from "react";
import { dateTimeToString, formatComma } from "../../utils/stringFormat";
import ReportLogWoodDetail from "../../components/reports/ReportLogWoodDetail";
import { URL_LOG_WOOD } from "../../constance/urls";
import useDropdownItem from "../../hooks/useDropdownItem";
import { useTranslation } from "react-i18next";


function ReportLogWoodSpeciesView() {
  const logWoodSpeciesChoices = useDropdownItem({
    url: URL_LOG_WOOD.LOG_WOOD_SPECIES_GRADE,
  });
  const { t } = useTranslation();

  const defaultColumns = [
    {
      title: t("datas.index"),
      dataIndex: "index",
      width: 80,
    },
    {
      title: t("date_title"),
      dataIndex: "in_date_time",
      width: 140,
      render: (value) => <p>{dateTimeToString(value)}</p>,
    },
    {
      title: t("trucks.license_plate"),
      dataIndex: "license_plate",
      width: 120,
    },
    {
      title: t("truck_companies.code"),
      dataIndex: "truck_company_code",
      width: 120,
    },
    {
      title: t("truck_companies.name"),
      dataIndex: "truck_company_name",
      width: 220,
    },
  ];

  const [columns, setColumns] = React.useState(defaultColumns);

  React.useEffect(() => {
    if (!logWoodSpeciesChoices.response?.length) {
      return;
    }
    setColumns([
      ...defaultColumns,
      ...logWoodSpeciesChoices.response
        .sort((a, b) => (a.name < b.name ? -1 : 1))
        .map((species) => ({
          title: species.name,
          children: [
            {
              title: t("units.tonne"),
              dataIndex: `report.${species.name}_weight`,
              render: (value) => formatComma(value, 3),
            },
            {
              title: "%",
              dataIndex: `report.${species.name}_percent`,
              render: (text, record) => formatComma(record.percent)
            },
          ],
        })),
      {
        title: t("datas.total"),
        children: [
          {
            title: t("units.tonne"),
            dataIndex: "report.total_weight",
            render: (value) => formatComma(value, 3),
          },
          {
            title: "%",
            dataIndex: "report.total_percent",
            render: (text, record) => formatComma(record.total_percent)
          },
        ],
      },
    ]);
  }, [logWoodSpeciesChoices.response, t]);


  return (
    <>
      <ReportLogWoodDetail
        title={t("menus.report_menus.log_wood_menus.log_wood_species")}
        url={URL_LOG_WOOD.REPORT_LOG_WOOD_SPECIES}
        tableColumns={columns}
        exportUrl={URL_LOG_WOOD.REPORT_LOG_WOOD_SPECIES_EXPORT}
      />
    </>
  );
}

export default ReportLogWoodSpeciesView;
